/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  WeaknessMappingDto,
  WeaknessMappingStalenessResponse,
  WeaknessMappingUpsertRequest,
} from '../models/index';
import {
    WeaknessMappingDtoFromJSON,
    WeaknessMappingDtoToJSON,
    WeaknessMappingStalenessResponseFromJSON,
    WeaknessMappingStalenessResponseToJSON,
    WeaknessMappingUpsertRequestFromJSON,
    WeaknessMappingUpsertRequestToJSON,
} from '../models/index';

export interface UpsertWeaknessCspmMappingRequest {
    sessionId: string;
    platform: UpsertWeaknessCspmMappingPlatformEnum;
    controlId: string;
    weaknessMappingUpsertRequest: WeaknessMappingUpsertRequest;
}

export interface UpsertWeaknessScannerMappingRequest {
    sessionId: string;
    scannerType: UpsertWeaknessScannerMappingScannerTypeEnum;
    scannerCheckId: string;
    weaknessMappingUpsertRequest: WeaknessMappingUpsertRequest;
}

export interface WeaknessCspmMappingStalenessRequest {
    sessionId: string;
    limit?: number;
}

export interface WeaknessScannerMappingStalenessRequest {
    sessionId: string;
    limit?: number;
}

/**
 * MDMWeaknessMappingsApi - interface
 * 
 * @export
 * @interface MDMWeaknessMappingsApiInterface
 */
export interface MDMWeaknessMappingsApiInterface {
    /**
     * 
     * @summary Upsert CSPM weakness mapping
     * @param {string} sessionId 
     * @param {'WIZ' | 'DEFENDER_CLOUD' | 'AWS_SECURITY_HUB' | 'PRISMA_CLOUD' | 'GCP_SCC' | 'AZURE_POLICY' | 'GENERIC'} platform 
     * @param {string} controlId 
     * @param {WeaknessMappingUpsertRequest} weaknessMappingUpsertRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMWeaknessMappingsApiInterface
     */
    upsertWeaknessCspmMappingRaw(requestParameters: UpsertWeaknessCspmMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WeaknessMappingDto>>;

    /**
     * Upsert CSPM weakness mapping
     */
    upsertWeaknessCspmMapping(requestParameters: UpsertWeaknessCspmMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WeaknessMappingDto>;

    /**
     * 
     * @summary Upsert scanner weakness mapping
     * @param {string} sessionId 
     * @param {'QUALYS_PC_QID' | 'NESSUS_COMPLIANCE_PLUGIN' | 'INTUNE_RULE' | 'NINJAONE_CHECK' | 'GENERIC'} scannerType 
     * @param {string} scannerCheckId 
     * @param {WeaknessMappingUpsertRequest} weaknessMappingUpsertRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMWeaknessMappingsApiInterface
     */
    upsertWeaknessScannerMappingRaw(requestParameters: UpsertWeaknessScannerMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WeaknessMappingDto>>;

    /**
     * Upsert scanner weakness mapping
     */
    upsertWeaknessScannerMapping(requestParameters: UpsertWeaknessScannerMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WeaknessMappingDto>;

    /**
     * 
     * @summary Stale CSPM weakness mappings
     * @param {string} sessionId 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMWeaknessMappingsApiInterface
     */
    weaknessCspmMappingStalenessRaw(requestParameters: WeaknessCspmMappingStalenessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WeaknessMappingStalenessResponse>>;

    /**
     * Stale CSPM weakness mappings
     */
    weaknessCspmMappingStaleness(requestParameters: WeaknessCspmMappingStalenessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WeaknessMappingStalenessResponse>;

    /**
     * 
     * @summary Stale scanner weakness mappings
     * @param {string} sessionId 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMWeaknessMappingsApiInterface
     */
    weaknessScannerMappingStalenessRaw(requestParameters: WeaknessScannerMappingStalenessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WeaknessMappingStalenessResponse>>;

    /**
     * Stale scanner weakness mappings
     */
    weaknessScannerMappingStaleness(requestParameters: WeaknessScannerMappingStalenessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WeaknessMappingStalenessResponse>;

}

/**
 * 
 */
export class MDMWeaknessMappingsApi extends runtime.BaseAPI implements MDMWeaknessMappingsApiInterface {

    /**
     * Upsert CSPM weakness mapping
     */
    async upsertWeaknessCspmMappingRaw(requestParameters: UpsertWeaknessCspmMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WeaknessMappingDto>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling upsertWeaknessCspmMapping().'
            );
        }

        if (requestParameters['platform'] == null) {
            throw new runtime.RequiredError(
                'platform',
                'Required parameter "platform" was null or undefined when calling upsertWeaknessCspmMapping().'
            );
        }

        if (requestParameters['controlId'] == null) {
            throw new runtime.RequiredError(
                'controlId',
                'Required parameter "controlId" was null or undefined when calling upsertWeaknessCspmMapping().'
            );
        }

        if (requestParameters['weaknessMappingUpsertRequest'] == null) {
            throw new runtime.RequiredError(
                'weaknessMappingUpsertRequest',
                'Required parameter "weaknessMappingUpsertRequest" was null or undefined when calling upsertWeaknessCspmMapping().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['platform'] != null) {
            queryParameters['platform'] = requestParameters['platform'];
        }

        if (requestParameters['controlId'] != null) {
            queryParameters['controlId'] = requestParameters['controlId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/mdm/weakness-mappings/cspm`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WeaknessMappingUpsertRequestToJSON(requestParameters['weaknessMappingUpsertRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WeaknessMappingDtoFromJSON(jsonValue));
    }

    /**
     * Upsert CSPM weakness mapping
     */
    async upsertWeaknessCspmMapping(requestParameters: UpsertWeaknessCspmMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WeaknessMappingDto> {
        const response = await this.upsertWeaknessCspmMappingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upsert scanner weakness mapping
     */
    async upsertWeaknessScannerMappingRaw(requestParameters: UpsertWeaknessScannerMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WeaknessMappingDto>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling upsertWeaknessScannerMapping().'
            );
        }

        if (requestParameters['scannerType'] == null) {
            throw new runtime.RequiredError(
                'scannerType',
                'Required parameter "scannerType" was null or undefined when calling upsertWeaknessScannerMapping().'
            );
        }

        if (requestParameters['scannerCheckId'] == null) {
            throw new runtime.RequiredError(
                'scannerCheckId',
                'Required parameter "scannerCheckId" was null or undefined when calling upsertWeaknessScannerMapping().'
            );
        }

        if (requestParameters['weaknessMappingUpsertRequest'] == null) {
            throw new runtime.RequiredError(
                'weaknessMappingUpsertRequest',
                'Required parameter "weaknessMappingUpsertRequest" was null or undefined when calling upsertWeaknessScannerMapping().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['scannerType'] != null) {
            queryParameters['scannerType'] = requestParameters['scannerType'];
        }

        if (requestParameters['scannerCheckId'] != null) {
            queryParameters['scannerCheckId'] = requestParameters['scannerCheckId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/mdm/weakness-mappings/scanner`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WeaknessMappingUpsertRequestToJSON(requestParameters['weaknessMappingUpsertRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WeaknessMappingDtoFromJSON(jsonValue));
    }

    /**
     * Upsert scanner weakness mapping
     */
    async upsertWeaknessScannerMapping(requestParameters: UpsertWeaknessScannerMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WeaknessMappingDto> {
        const response = await this.upsertWeaknessScannerMappingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Stale CSPM weakness mappings
     */
    async weaknessCspmMappingStalenessRaw(requestParameters: WeaknessCspmMappingStalenessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WeaknessMappingStalenessResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling weaknessCspmMappingStaleness().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/weakness-mappings/cspm/staleness`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WeaknessMappingStalenessResponseFromJSON(jsonValue));
    }

    /**
     * Stale CSPM weakness mappings
     */
    async weaknessCspmMappingStaleness(requestParameters: WeaknessCspmMappingStalenessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WeaknessMappingStalenessResponse> {
        const response = await this.weaknessCspmMappingStalenessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Stale scanner weakness mappings
     */
    async weaknessScannerMappingStalenessRaw(requestParameters: WeaknessScannerMappingStalenessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WeaknessMappingStalenessResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling weaknessScannerMappingStaleness().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/weakness-mappings/scanner/staleness`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WeaknessMappingStalenessResponseFromJSON(jsonValue));
    }

    /**
     * Stale scanner weakness mappings
     */
    async weaknessScannerMappingStaleness(requestParameters: WeaknessScannerMappingStalenessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WeaknessMappingStalenessResponse> {
        const response = await this.weaknessScannerMappingStalenessRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const UpsertWeaknessCspmMappingPlatformEnum = {
    Wiz: 'WIZ',
    DefenderCloud: 'DEFENDER_CLOUD',
    AwsSecurityHub: 'AWS_SECURITY_HUB',
    PrismaCloud: 'PRISMA_CLOUD',
    GcpScc: 'GCP_SCC',
    AzurePolicy: 'AZURE_POLICY',
    Generic: 'GENERIC'
} as const;
export type UpsertWeaknessCspmMappingPlatformEnum = typeof UpsertWeaknessCspmMappingPlatformEnum[keyof typeof UpsertWeaknessCspmMappingPlatformEnum];
/**
 * @export
 */
export const UpsertWeaknessScannerMappingScannerTypeEnum = {
    QualysPcQid: 'QUALYS_PC_QID',
    NessusCompliancePlugin: 'NESSUS_COMPLIANCE_PLUGIN',
    IntuneRule: 'INTUNE_RULE',
    NinjaoneCheck: 'NINJAONE_CHECK',
    Generic: 'GENERIC'
} as const;
export type UpsertWeaknessScannerMappingScannerTypeEnum = typeof UpsertWeaknessScannerMappingScannerTypeEnum[keyof typeof UpsertWeaknessScannerMappingScannerTypeEnum];
